import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {SAJASEUNGEO_BOOKMARK_API_URL} from '../../defines/protocol';
import {ApiService} from '../api/api.service';
import {TotalService} from '../total/total.service';
import {WordBookmarkService} from './word-bookmark.service';


@Injectable()
export class SajaseungeoBookmarkService extends WordBookmarkService {

  constructor(
    protected override api: ApiService,
    private totalSvc: TotalService,
  ) {
    super(api);
    this.urlApi = SAJASEUNGEO_BOOKMARK_API_URL;
  }

  public override sendBookmark(id: string, add: boolean = true): Observable<boolean> {
    return super.sendBookmark(id, add).pipe(
      map(data => {
        this.totalSvc.updateSajaseungeoBookmarkCount(add);
        return data;
      }),
    );
  }
}
